import React, { PureComponent } from "react";
import Globalize from "globalize";
import { DATATEST } from "constants/integration";

const styles = {
    base: {
        position: "fixed",
        top: "50%",
        left: "50%",
        width: "408px",
        maxWidth: "80%",
        zIndex: 990,
        transform: "translate(-50%, -50%)",
        textAlign: "center",
    },
    h1: {
        color: "#222",
    },
    h5: {
        textTransform: "none",
    },
};

class PageNotFound extends PureComponent {
    render() {
        const { title, description, featureDisabled } = this.props;

        const featuredDisabledMessage = featureDisabled
            ? Globalize.formatMessage("This feature is disabled. Please contact the NuOrder sales team to enable.")
            : null;

        return (
            <div style={styles.base}>
                <h1 data-test={DATATEST.PAGE_NOT_FOUND.NOT_FOUND} style={styles.h1}>
                    {title || Globalize.formatMessage("Sorry, this page isn't available")}
                </h1>
                <h5 style={styles.h5}>
                    {description ||
                        featuredDisabledMessage ||
                        Globalize.formatMessage(
                            "The resource link may be broken, be removed, or you may not have permission to view it."
                        )}
                </h5>
            </div>
        );
    }
}

export default PageNotFound;
